// Spec 2026-07-24 v9 §I18n: compact language toggle used on the auth pages
// (login/register) AND in the app header. Clicking flips ar ↔ en, persists
// the choice to localStorage (via i18next detector), and re-renders every
// component using `useTranslation`.

import { useTranslation } from "react-i18next";
import { Globe } from "@phosphor-icons/react";

export default function LanguageToggle({ compact = false, className = "" }) {
  const { i18n, t } = useTranslation();
  const isEn = i18n.language === "en";
  const next = isEn ? "ar" : "en";

  const flip = () => {
    i18n.changeLanguage(next);
  };

  return (
    <button
      type="button"
      onClick={flip}
      data-testid="language-toggle"
      title={isEn ? "التبديل إلى العربية" : "Switch to English"}
      aria-label={isEn ? "Switch to Arabic" : "Switch to English"}
      className={
        "inline-flex items-center gap-1.5 rounded-full border border-primary/40 " +
        "bg-primary/10 hover:bg-primary/20 text-primary text-xs font-bold " +
        (compact ? "px-2 py-1" : "px-3 py-1.5") +
        " transition-colors " +
        className
      }
    >
      <Globe size={14} weight="bold" />
      <span>{t("language.toggle")}</span>
    </button>
  );
}
